/** Parses a string to JSON. If the given object is not undefined or null, a fallback can be provided */
export const JSONParseSafe = (o?: string | null, fallback?: any): any =>
  o ? JSON.parse(o) : fallback;

/** Stringifies an object. If no object is provided, a fallback can be specified. */
export const JSONStringifySafe = (o?: any, fallback?: any): string =>
  o ? JSON.stringify(o) : fallback;
